import {Action, handleActions} from 'redux-actions';
import {IAppConfig} from '../../@types/appConfig';
import {IVideoOptions} from '../../@types/videoOptions';
import {IGTMOptions} from '../../@types/gtm';
import {SET_PLAYER_WIDTH, SET_TEMPLATE_COLORS, SET_USER_IP} from '../actions/configuration';
import {IControlBarControls} from '../../@types/controlBarControls';

export const DEFAULT_WIDTH_OPTIONS = {
  maxWidth: 5120,
  width: 1200,
  minWidth: 1200
};

export const DEFAULT_VIDEO_OPTIONS: IVideoOptions = {
  showControls: true,
  showNavigationBar: true,
  showSpeedSetting: true,
  showVolume: true,
  showNextPrevSubtitleButtons: false,
  showNextPrevSeekButtons: true,
  showNextPrevFrameButtons: false,
  showFramesTime: true,
  showMillisecondsTime: true,
  widthOptions: null
};

const DEFAULT_GTM_OPTIONS: IGTMOptions = {
  gtmId: '',
  auth: '',
  preview: ''
};

export const DEFAULT_CONTROL_BAR_CONTROLS: IControlBarControls[] = [
  'GoToBeginning',
  'FastRewind',
  'QuickBack',
  'FrameRewind',
  'Play',
  'FrameAdvance',
  'QuickFwd',
  'FastFwd',
  'GoToEnd',
  'GoToLocation',
  'Loop',
  'Speed',
  'Volume',
  'GeneralSettings',
  'AudioAndSubs',
  'FullScreenMode'
];

export const DEFAULT_CONFIGURATION_STATE: IAppConfig = {
  version: '0.1',
  userIp: '',
  userEmail: 'test@user.com',
  apiAccessToken: '',
  templateColors: {
    main: '#ffffff',
    highlight: '#378fef',
    tooltipBackground: 'rgba(27, 30, 36, 0.89)'
  },
  showingDropdownTimeout: 250,
  videoOptions: DEFAULT_VIDEO_OPTIONS,
  gtmOptions: DEFAULT_GTM_OPTIONS,
  controlBarControls: DEFAULT_CONTROL_BAR_CONTROLS,
  curationModeEnabled: false,
  bitmovinKey: 'da8ff527-3b1b-401e-a0b7-0918fb477477',
  autoSelectPlaybackConfig: false,
  doAssetContentTypeCheck: false,
  environment: 'dev'
};

export default handleActions<IAppConfig, any>(
  {
    [SET_PLAYER_WIDTH]: (state: IAppConfig, action: Action<SET_PLAYER_WIDTH>): IAppConfig => ({
      ...state,
      videoOptions: {
        ...state.videoOptions,
        widthOptions: {
          ...state.videoOptions.widthOptions,
          width: action.payload
        }
      }
    }),
    [SET_TEMPLATE_COLORS]: (state: IAppConfig, action: Action<SET_TEMPLATE_COLORS>): IAppConfig => ({
      ...state,
      templateColors: {
        ...state.templateColors,
        ...action.payload
      }
    }),
    [SET_USER_IP]: (state: IAppConfig, action: Action<SET_USER_IP>): IAppConfig => ({
      ...state,
      userIp: action.payload
    })
  },
  DEFAULT_CONFIGURATION_STATE
);
